export default "__VITE_ASSET__BRQd1CHw__"